/* PARWIN: cookie consent banner tracking. Fires a custom event on Accept / Decline / Manage
   clicks (and on Shopify's official consent decision) to whatever analytics is present:
   dataLayer (GTM/GA4), gtag (GA4), and Microsoft Clarity (custom tag + event). */
(function () {
  function track(choice) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'cookie_consent', cookie_consent_choice: choice }); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'cookie_consent', { choice: choice }); } catch (e) {}
    try { if (typeof window.clarity === 'function') { window.clarity('set', 'cookie_consent', choice); window.clarity('event', 'cookie_consent_' + choice); } } catch (e) {}
  }
  // 1) direct button clicks (what the visitor clicked)
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('button, a') : null;
    if (!el) return;
    var sig = ((el.id || '') + ' ' + (typeof el.className === 'string' ? el.className : '')).toLowerCase();
    if (sig.indexOf('btn-accept') > -1) track('accept');
    else if (sig.indexOf('btn-decline') > -1) track('decline');
    else if (sig.indexOf('manage-prefs') > -1 || sig.indexOf('btn-manage') > -1) track('manage_preferences');
  }, true);
  // 2) Shopify's official consent decision (final accepted vs declined state)
  document.addEventListener('visitorConsentCollected', function (e) {
    try { var c = (e && e.detail) || {}; track((c.analytics === true || c.marketing === true) ? 'consent_accepted' : 'consent_declined'); } catch (err) {}
  });
})();
